
//
// Animations
//
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
    if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(() => {
            entry.target.classList.add('reveal');
        }, delay);
    }
    });
}, { threshold: 0.1 });

// Flashpassion markup
const sections = document.querySelectorAll('.animup');

sections.forEach(section => {
    observer.observe(section);
});


document.addEventListener('DOMContentLoaded', function () {
    (function (window, document) {
        // Modal
        document.querySelectorAll('.modal').forEach(function (modal) {
            const modalId = modal.getAttribute('data-bs-target');
            modal.addEventListener('hide.bs.modal', function (event) {
                //event.preventDefault(); // stop bs
                event.stopPropagation();
                modal.classList.add('reverse');
                //instance = window.Modal.getOrCreateInstance(document.getElementById(modalId));
                //instance = window.Offcanvas.getInstance(document.getElementById(modalId));
                //setTimeout(function () {
                //    instance.hide();
                //}, 600);
            });
            modal.addEventListener('show.bs.modal', function () {
                modal.classList.remove('reverse');
            });
        });

        // offcanvas
        document.querySelectorAll('.offcanvas').forEach(function (offcanvas) {
            const offcanvasId = offcanvas.getAttribute('data-bs-target');
            offcanvas.addEventListener('hide.bs.offcanvas', function (event) {
                //event.preventDefault();
                event.stopPropagation();
                offcanvas.classList.add('reverse');
                /*console.log(event);
                //instance = window.Offcanvas.getOrCreateInstance(document.getElementById(offcanvasId));
                instance = window.Offcanvas.getInstance(document.getElementById(offcanvasId));
                setTimeout(function () {
                    instance.hide();
                }, 600);*/
            });
            offcanvas.addEventListener('show.bs.offcanvas', function () {
                offcanvas.classList.remove('reverse');
            });
        });
    })(window, document);
});
